export interface IAuthPopupOptions {
  persistent?: boolean
}

export const useAuthPopupStore = defineStore('auth-popup', () => {
  const isOpen = ref(false)
  const persistent = ref(false)

  let resolvePromise: ((value: boolean) => void) | null = null

  /**
   * Открыть popup авторизации.
   * Возвращает Promise<boolean>: true — успешный вход, false — закрыт без входа.
   */
  function open(options: IAuthPopupOptions = {}): Promise<boolean> {
    persistent.value = options.persistent ?? false
    isOpen.value = true
    return new Promise<boolean>((resolve) => {
      resolvePromise = resolve
    })
  }

  function close() {
    isOpen.value = false
    if (resolvePromise) {
      resolvePromise(false)
      resolvePromise = null
    }
  }

  function handleSuccess() {
    if (resolvePromise) {
      resolvePromise(true)
      resolvePromise = null
    }
    if (persistent.value) {
      window.location.reload()
    }
    else {
      isOpen.value = false
    }
  }

  function handleModelUpdate(value: boolean) {
    isOpen.value = value
    if (!value && resolvePromise) {
      resolvePromise(false)
      resolvePromise = null
    }
  }

  return {
    isOpen,
    persistent,
    open,
    close,
    handleSuccess,
    handleModelUpdate,
  }
})
